import { formatCurrency } from '@/common/helpers/mask.helpers';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: any;
  baseValue: number;
}

export default function PixOrBoletoInformations({ formik }: Props) {
  return (
    <>
      {/* Valor da entrada */}
      <div className="bg-gray-50 p-3 rounded border">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Valor da entrada (R$)
        </label>
        <div className="text-lg font-semibold text-gray-900">
          {formatCurrency(formik.values.boletoOrPix.entryValue || 0)}
        </div>
      </div>

      {/* Resumo PIX/Boleto */}
      <div className="bg-gradient-to-r from-green-50 to-green-100 p-4 rounded-lg border border-green-200">
        <label className="block text-sm font-medium text-green-800 mb-2">
          {formik.values.billingType === 'PIX' ? '📱 Resumo PIX' : '📄 Resumo Boleto'}
        </label>

        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Entrada:</span>
            <span className="font-medium text-green-600">{formatCurrency(formik.values.boletoOrPix.entryValue || 0)}</span>
          </div>

          {/* Sempre mostrar resumo do valor a parcelar */}
          <div className="mt-2">
            <div className="flex justify-between">
              <span className="text-gray-600">A parcelar:</span>
              <span className="font-medium">{formatCurrency(formik.values.boletoOrPix.remainingValue || 0)}</span>
            </div>

            <div className="border-t border-green-200 pt-2 mt-2">
              {Number(formik.values.boletoOrPix.installments) > 1 ? (
                <div className="flex justify-between">
                  <span className="text-green-800 font-medium">Parcelamento:</span>
                  <span className="font-bold text-green-700">
                    {formik.values.boletoOrPix.installmentsText}
                  </span>
                </div>
              ) : (
                <div className="flex justify-between">
                  <span className="text-green-800 font-medium">Pagamento:</span>
                  <span className="font-bold text-green-700">À vista</span>
                </div>
              )}
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded p-2 mt-2">
            <div className="flex justify-between text-sm">
              <span className="font-medium text-yellow-800">Taxa:</span>
              <span className="font-bold text-yellow-900">Sem taxa</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}